const logPlatformUserAction = (
  orgId,
  objectId = "",
  objectType = "",
  actionType = ""
) => {
  window.uiEventTracker.trackUserInteractionWithPageContext("platform.action", {
    organization_id: orgId.toString(),
    object_id: objectId,
    object_type: objectType,
    action_type: actionType,
    referrer: window.document.referrer,
  })
}

export default logPlatformUserAction
